<app-grid-list [data]="gridData" [isEditable]="isEditable" [isShortVersionNeeded]="true"></app-grid-list>
